import React from "react"

export const StarIcon = ({ size = 40, color = "#554DF1" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M24.1121 13.3613L24.7941 14.8069L26.3743 15.0472L35.8441 16.487L28.9004 23.5686L27.836 24.6541L28.082 26.1544L29.6922 35.9743L21.4456 31.4343L19.9992 30.638L18.5525 31.434L10.3053 35.9722L11.9156 26.1516L12.1616 24.6513L11.0972 23.5658L4.15578 16.4865L13.6182 15.0471L15.1983 14.8068L15.8802 13.3613L19.9961 4.63691L24.1121 13.3613ZM1.93975 15.7415L1.92431 15.7452L1.93975 15.7415Z'
        stroke={color}
        strokeWidth='6'
      />
    </svg>
  )
}
